export default __webpack_public_path__ + "static/media/Mariques Black Leather Cache.d857d4ff.jpg";